import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../index";

const initialState = {
  action: false,
  open: false,
  message: "Note archived",
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right",
  },
  variant: "default",
  alert: {
    color: "primary",
    variant: "filled",
  },
  transition: "Fade",
  close: true,
  actionButton: false,
  sx: {},
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const snackbar = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    openSnackbar(state, action) {
      const {
        open,
        message,
        anchorOrigin,
        variant,
        alert,
        transition,
        close,
        actionButton,
        sx,
      } = action.payload;

      state.action = !state.action;
      state.open = open || initialState.open;
      state.message = message || initialState.message;
      state.anchorOrigin = anchorOrigin || initialState.anchorOrigin;
      state.variant = variant || initialState.variant;
      state.alert = {
        color: alert?.color || initialState.alert.color,
        variant: alert?.variant || initialState.alert.variant,
      };
      state.transition = transition || initialState.transition;
      state.close = close === false ? close : initialState.close;
      state.actionButton = actionButton || initialState.actionButton;
      state.sx = sx || initialState.sx;
    },

    closeSnackbar(state) {
      state.open = false;
    },
  },
});

export default snackbar.reducer;

export const { closeSnackbar, openSnackbar } = snackbar.actions;

/* Alias for `openSnackbar` simplify commonly used messages */
export function displayToast(message, type) {
  return async () => {
    dispatch(
      snackbar.actions.openSnackbar({
        open: true,
        message,
        variant: type?.variant,
        alert: type?.alert,
        anchorOrigin: type?.anchorOrigin,
        sx: type?.sx,
      })
    );
  };
}

export function closeToast() {
  return async () => {
    dispatch(snackbar.actions.closeSnackbar());
  };
}
